import React from 'react'
import CheckEmailTemplate from '../../../Templates/Auth/ForgotPassword/CheckEmail.template'

function CheckEmailPage({profileData}) {
  return (
    <CheckEmailTemplate />
  )
}

export default CheckEmailPage